import { render, staticRenderFns } from "./wiki-content.vue?vue&type=template&id=6837b888"
import script from "./wiki-content.vue?vue&type=script&lang=js"
export * from "./wiki-content.vue?vue&type=script&lang=js"
import style0 from "./wiki-content.vue?vue&type=style&index=0&id=6837b888&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports